<script>
import { createNamespacedHelpers } from 'vuex';
import { ScToast } from '@intelipost-js/secure-components';

import BillingLoadingModal from '../../../components/billing-loading-modal/BillingLoadingModal.vue';
import ScConfirmationModal from '../../../../../components/sc-confirmation-modal/ScConfirmationModal.vue';

const { mapState } = createNamespacedHelpers('recon/billing');

export default {
  name: 'NewBillingTemplateSavingModal',
  data() {
    return {
      hasSaveError: false,
      isErrorModalActive: false,
    };
  },
  computed: {
    ...mapState(['savingBillingTemplate', 'savingBillingTemplateError']),
  },
  watch: {
    savingBillingTemplateError(error) {
      if (error) {
        const isExpectedError = error.indexOf('billing.template.already-exists') !== -1;
        this.hasSaveError = !isExpectedError;
        this.isErrorModalActive = isExpectedError;
      }
    },
    savingBillingTemplate(isSaving) {
      if (!isSaving && !this.isErrorModalActive) {
        if (this.hasSaveError) ScToast.danger('Houve uma falha ao salvar o modelo');
        this.$router.push({ name: 'billing-my-files-page', query: { activeTab: '2' } });
      }
    },
  },
  components: { BillingLoadingModal, ScConfirmationModal, ScToast },
};
</script>

<template>
  <section>
    <billing-loading-modal text="Aguarde enquanto criamos o template da sua fatura" :is-active="savingBillingTemplate"/>
    <sc-confirmation-modal
      :is-active.sync="isErrorModalActive"
      type="normal"
      title="Modelo já cadastrado para a transportadora e método de entrega selecionado"
      cancelText="Selecionar outra transportadora e método de entrega"
      confirm-text="Continuar cadastro"
      :messages="[
        'Identificamos que você já tem um modelo cadastrado para a transportadora e método de entrega selecionado.',
        'Caso você continue o cadastro, o modelo existente será substituído pelo novo. Se preferir, selecione outra transportadora e método de entrega.'
      ]"
      @onConfirm="() => $emit('onOverwriteConfirm')"
      @onCancel="() => $emit('onOverwriteCancel')"
    />
  </section>
</template>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateSavingModal.vue